'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevrondown from '@common/icon/SvgChevrondown';
import { cn } from '@core/utils';
import useEmblaCarousel from 'embla-carousel-react';
import { useState } from 'react';
import { Image } from '@/components/client';
import { Rating } from '@/components/molecule/Rating';
interface MarketReviewCardProps {
  rating: number;
  /** 작성자 닉네임. 결측이면 날짜만 렌더한다 */
  reviewer?: string | null;
  date: string;
  content: string;
  imageUrlList?: string[];
  productName?: string;
  answer?: string;
  answerDate?: string;
  onClick?: () => void;
}
const CONTENT_LIMIT = 100;
const ANSWER_LIMIT = 60;
export const MarketReviewCard = t0 => {
  const $ = _c(53);
  const {
    rating,
    reviewer,
    date,
    content,
    imageUrlList: t1,
    productName,
    answer,
    answerDate,
    onClick
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const imageUrlList = t2;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isAnswerExpanded, setIsAnswerExpanded] = useState(false);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [emblaRef] = useEmblaCarousel(t3);
  const t4 = onClick ? "button" : undefined;
  const t5 = onClick ? 0 : undefined;
  const t6 = onClick ? "\uB9AC\uBDF0 \uC0C1\uC138 \uBCF4\uAE30" : undefined;
  const t7 = onClick && "cursor-pointer";
  let t8;
  if ($[3] !== t7) {
    t8 = cn("flex min-w-0 flex-col gap-12 py-20", t7);
    $[3] = t7;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== onClick) {
    t9 = onClick ? e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    } : undefined;
    $[5] = onClick;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== rating) {
    t10 = <Rating value={rating} size={16} />;
    $[7] = rating;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== reviewer) {
    t11 = reviewer ? <span className="text-Gray-550 typo-caption1">{reviewer}</span> : null;
    $[9] = reviewer;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== date || $[12] !== reviewer) {
    t12 = reviewer && date ? <div className="h-10 border-l border-Gray-300" /> : null;
    $[11] = date;
    $[12] = reviewer;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== date) {
    t13 = date ? <span className="text-Gray-550 typo-caption1">{date}</span> : null;
    $[14] = date;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t11 || $[17] !== t12 || $[18] !== t13) {
    t14 = <div className="flex items-center gap-8">{t11}{t12}{t13}</div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t10 || $[21] !== t14) {
    t15 = <div className="flex flex-col gap-8">{t10}{t14}</div>;
    $[20] = t10;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== productName) {
    t16 = productName && <p className="font-400 text-Gray-600 typo-body4">{productName}</p>;
    $[23] = productName;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== emblaRef || $[26] !== imageUrlList) {
    t17 = imageUrlList.length > 0 && <div className="relative w-full overflow-hidden" ref={emblaRef}><div className="flex gap-8">{imageUrlList.map(_temp)}</div></div>;
    $[25] = emblaRef;
    $[26] = imageUrlList;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== content || $[29] !== isExpanded) {
    t18 = content.length > CONTENT_LIMIT && !isExpanded ? `${content.slice(0, CONTENT_LIMIT)}...` : content;
    $[28] = content;
    $[29] = isExpanded;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== content.length || $[32] !== isExpanded) {
    t19 = content.length > CONTENT_LIMIT && !isExpanded && <span onClick={e_0 => {
      e_0.stopPropagation();
      setIsExpanded(true);
    }} className="inline-block cursor-pointer whitespace-nowrap px-4 font-600 text-Gray-550 typo-body3">더보기</span>;
    $[31] = content.length;
    $[32] = isExpanded;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] !== t18 || $[35] !== t19) {
    t20 = <p className="whitespace-pre-line break-all font-500 text-Gray-800 typo-body3">{t18}{t19}</p>;
    $[34] = t18;
    $[35] = t19;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== answer || $[38] !== answerDate || $[39] !== isAnswerExpanded) {
    t21 = answer && <div className="flex flex-col rounded-medium bg-Gray-25 p-20"><div className="flex items-center justify-between pb-4"><p className="font-600 text-Gray-700 typo-body4">판매자</p>{answerDate && <p className="font-400 text-Gray-550 typo-caption1">{answerDate}</p>}</div><p className="whitespace-pre-line break-all font-400 text-Gray-700 typo-body4">{answer.length > ANSWER_LIMIT && !isAnswerExpanded ? `${answer.slice(0, ANSWER_LIMIT)}...` : answer}</p>{answer.length > ANSWER_LIMIT && <button type="button" className="mt-8 flex items-center gap-4 self-start" onClick={e_1 => {
        e_1.stopPropagation();
        setIsAnswerExpanded(_temp2);
      }}><span className="font-600 text-Gray-550 typo-caption1">{isAnswerExpanded ? "\uC811\uAE30" : "\uB354\uBCF4\uAE30"}</span><SvgChevrondown className={cn("size-12 text-Gray-550 transition-transform duration-300", isAnswerExpanded && "-rotate-180")} /></button>}</div>;
    $[37] = answer;
    $[38] = answerDate;
    $[39] = isAnswerExpanded;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== onClick || $[42] !== t15 || $[43] !== t16 || $[44] !== t17 || $[45] !== t20 || $[46] !== t21 || $[47] !== t4 || $[48] !== t5 || $[49] !== t6 || $[50] !== t8 || $[51] !== t9) {
    t22 = <div role={t4} tabIndex={t5} aria-label={t6} className={t8} onClick={onClick} onKeyDown={t9}>{t15}{t16}{t17}{t20}{t21}</div>;
    $[41] = onClick;
    $[42] = t15;
    $[43] = t16;
    $[44] = t17;
    $[45] = t20;
    $[46] = t21;
    $[47] = t4;
    $[48] = t5;
    $[49] = t6;
    $[50] = t8;
    $[51] = t9;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  return t22;
};
function _temp(url, index) {
  return <div key={index} className="flex-[0_0_auto]"><Image src={url} alt={`리뷰 이미지 ${index + 1}`} width={128} height={128} className="block aspect-square object-cover" /></div>;
}
function _temp2(prev) {
  return !prev;
}